@if (control) {
  <form>
    <fieldset [ngClass]="{ 'ba-error': hasErrorAndTrackPiwik }"
      class="ba-input-group"
      [attr.aria-labelledby]="label ? id+'_label_text' : labelId"
      [attr.aria-required]="required"
      [attr.data-value]="getValue()"
      id="{{id}}_data_value">
      @if (label) {
        <legend
          id="{{id}}_label">
          <span [id]="id+'_label_text'"
          [innerHtml]="label | translate"></span>
          @if (required) {
            <span aria-hidden="true">*</span>
          }
          <span class="sr-only">{{ label }}</span>
          @if (hinweis) {
            <wba-fragezeichen
              [dataModal]="hinweis?.modal"
              [dataTarget]="hinweis?.target"
              [dataAnalyticsName]="dataAnalyticsNameInfo"
              id="{{id}}_fragezeichen"
              [label]="label"
              smaller="true"/>
          }
        </legend>
      }
      <div class="ba-radio-group"
        [ngClass]="orientation"
        id="{{id}}_component"
        role="radiogroup">
        <div class="form-check"
          [ngClass]="{'geo-input-label-wrapper': orientation == 'horizontal', 'form-group': orientation == 'vertical'}">
          <input #radioJa
            (click)="beforeChangeEvent.emit({event: $event, value: true})"
            (keydown.enter)="beforeChangeEvent.emit({event: $event, value: true})"
            (keydown.space)="beforeChangeEvent.emit({event: $event, value: true})"
            [(ngModel)]="value"
            [attr.data-error-label]="!!errorLabel ? errorLabel : label"
            [attr.data-error-message]="control.errors?.message"
            [attr.data-has-error]="control?.touched && !!control?.errors"
            [attr.name]="id+'-inputradio'"
            [ngModelOptions]="{standalone: true}"
            [value]="true"
            class="form-control"
            id="{{id}}_input_JA"
            type="radio">
          <label [for]='id+"_input_JA"'
          id="{{id}}_JA_label">Ja</label>
        </div>
        <div class="form-check"
          [ngClass]="{'geo-input-label-wrapper': orientation == 'horizontal', 'form-group': orientation == 'vertical'}">
          <input #radioNein
            (click)="beforeChangeEvent.emit({event: $event, value: false})"
            (keydown.enter)="beforeChangeEvent.emit({event: $event, value: false})"
            (keydown.space)="beforeChangeEvent.emit({event: $event, value: false})"
            [(ngModel)]="value"
            [attr.name]="id+ '-inputradio'"
            [ngModelOptions]="{standalone: true}"
            [value]="false"
            id="{{id}}_input_NEIN"
            type="radio">
          <label [for]='id+"_input_NEIN"'
          id="{{id}}_NEIN_label">Nein</label>
        </div>
      </div>
    </fieldset>
  </form>
}
